import { handleResponse, handleError, apiUrl } from "./apiUtils";

const baseUrl = apiUrl + "recipes";

export async function getRecipes() {
    try {
        let result = await fetch(baseUrl);
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}
export async function getRecipe(recipeId) {
    try {
        let result = await fetch(`${baseUrl}/${recipeId}`);
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function updateRecipe(recipeId, recipe) {
    try {
        let result = await fetch(`${baseUrl}/${recipeId}`, {
            method: "PUT",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(recipe)
        });
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function addRecipe(recipe) {
    try {
        let result = await fetch(baseUrl, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(recipe)
        });
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function deleteRecipe(recipeId) {
    try {
        let result = await fetch(`${baseUrl}/${recipeId}`, {
            method: "DELETE",
            headers: { "content-type": "application/json" }
        });
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}
